import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCreateReviewRequest = { reviews: '_review' };
var _bulkCreateReviewResponse = { results: '_bulkReviewResult' };
var _bulkDeleteReviewsRequest = {};
var _bulkDeleteReviewsResponse = {};
var _bulkReviewResult = { review: '_review' };
var _bulkUpdateModerationStatusRequest = {};
var _bulkUpdateModerationStatusResponse = {};
var _countReviewsRequest = {};
var _countReviewsResponse = {};
var _createReviewAndContactRequest = {};
var _createReviewRequest = { review: '_review' };
var _createReviewResponse = { review: '_review' };
var _deleteReviewRequest = {};
var _deleteReviewResponse = { review: '_review' };
var _getDeletedReviewRequest = {};
var _getDeletedReviewResponse = { review: '_review' };
var _getReviewRequest = {};
var _getReviewResponse = { review: '_review' };
var _queryReviewsRequest = {};
var _queryReviewsResponse = { results: '_review', reviews: '_review' };
var _removeReplyRequest = {};
var _removeReplyResponse = { review: '_review' };
var _reply = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _review = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    reviewDate: 'google.protobuf.Timestamp',
    relevanceScore: 'google.protobuf.DoubleValue',
    reply: '_reply',
};
var _setReplyRequest = {};
var _setReplyResponse = { review: '_review' };
var _updateModerationStatusRequest = {};
var _updateModerationStatusResponse = { review: '_review' };
var _updateReviewContentRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    mask: 'google.protobuf.FieldMask',
};
var _updateReviewContentResponse = { review: '_review' };
var _updateReviewRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    review: '_review',
};
var _updateReviewResponse = { review: '_review' };
function resolveComWixpressCritiqueReviewsReviewsUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/reviews',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/reviews',
                destPath: '/api',
            },
            {
                srcPath: '/_api/reviews/api/v1/reviews',
                destPath: '/api/v1/reviews',
            },
            {
                srcPath: '/_api/reviews/v1/reviews',
                destPath: '/v1/reviews',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/reviews',
                destPath: '/api',
            },
            {
                srcPath: '/reviews/api/v1/reviews',
                destPath: '/api/v1/reviews',
            },
            {
                srcPath: '/reviews/v1/reviews',
                destPath: '/v1/reviews',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/reviews',
                destPath: '/api',
            },
            {
                srcPath: '/_api/reviews/api/v1/reviews',
                destPath: '/api/v1/reviews',
            },
            {
                srcPath: '/_api/reviews/v1/reviews',
                destPath: '/v1/reviews',
            },
            {
                srcPath: '/_api/reviews/bulk/v1/reviews',
                destPath: '/v1/bulk/reviews',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/reviews',
                destPath: '/api',
            },
            {
                srcPath: '/_api/reviews/api/v1/reviews',
                destPath: '/api/v1/reviews',
            },
            {
                srcPath: '/_api/reviews/v1/reviews',
                destPath: '/v1/reviews',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/reviews',
                destPath: '/api',
            },
            {
                srcPath: '/_api/reviews/api/v1/reviews',
                destPath: '/api/v1/reviews',
            },
            {
                srcPath: '/_api/reviews/v1/reviews',
                destPath: '/v1/reviews',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves a review by ID.
 *
 * To include unpublished reviews, pass `returnPrivateReviews` as `true`. By default, unpublished
 * reviews are not returned.
 */
export function getReview(payload) {
    var _a = serializer(_getReviewRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getReviewResponse, {
        _reply: _reply,
        _review: _review,
    }).fromJSON;
    function __getReview(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.review',
            method: 'GET',
            methodFqn: 'com.wixpress.critique.reviews.Reviews.GetReview',
            url: resolveComWixpressCritiqueReviewsReviewsUrl({
                protoPath: '/v1/reviews/{reviewId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressCritiqueReviewsReviewsUrl({
                        protoPath: '/v1/reviews/{reviewId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getReview.fromReq = fromReq;
    __getReview.__isAmbassador = true;
    return __getReview;
}
/** Retrieves reviews from trash bin. */
export function getDeletedReview(payload) {
    var _a = serializer(_getDeletedReviewRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDeletedReviewResponse, {
        _reply: _reply,
        _review: _review,
    }).fromJSON;
    function __getDeletedReview(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.review',
            method: 'GET',
            methodFqn: 'com.wixpress.critique.reviews.Reviews.GetDeletedReview',
            url: resolveComWixpressCritiqueReviewsReviewsUrl({
                protoPath: '/v1/reviews/trash-bin/{reviewId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDeletedReview.fromReq = fromReq;
    __getDeletedReview.__isAmbassador = true;
    return __getDeletedReview;
}
/**
 * Creates a new review and a new contact.
 *
 *
 * When the review author is not a contact, use this endpoint. Include `name` and `email`,
 * as they're required to create the contact. If these parameters are missing, a new contact and
 * review won't be created.
 *
 * When the review author is already a contact, use either this endpoint or [Create Review](https://dev.wix.com/api/rest/reviews/create-review).
 * A new review is created but a new contact is not created. For a 3rd-party app, include `name` and `email`.
 *
 * After a review is created, it may require [moderation](https://dev.wix.com/api/rest/reviews/introduction#reviews_introduction_moderation).
 * @deprecated It has been replaced with com.wixpress.critique.reviews.CreateReview(), and will be removed on 2024-02-01.
 */
export function createReviewAndContact(payload) {
    var _a = serializer(_createReviewAndContactRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createReviewResponse, {
        _reply: _reply,
        _review: _review,
    }).fromJSON;
    function __createReviewAndContact(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.review',
            method: 'POST',
            methodFqn: 'com.wixpress.critique.reviews.Reviews.CreateReviewAndContact',
            url: resolveComWixpressCritiqueReviewsReviewsUrl({
                protoPath: '/v1/reviews/contact',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createReviewAndContact.fromReq = fromReq;
    __createReviewAndContact.__isAmbassador = true;
    return __createReviewAndContact;
}
/**
 * Creates a new review using a contact ID.
 *
 *
 * This endpoint requires a [`review.author.contactId`](https://dev.wix.com/api/rest/contacts).
 * After a review is created, it may require [moderation](https://dev.wix.com/docs/rest/api-reference/wix-reviews/reviews/introduction#moderation).
 *
 * If `authorName` is left empty, the [member's](https://dev.wix.com/docs/rest/api-reference/members/members/get-member) name will be used.
 * If the author is not a member, the field is left `null`.
 */
export function createReview(payload) {
    var _a = serializer(_createReviewRequest, { _reply: _reply, _review: _review }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createReviewResponse, {
        _reply: _reply,
        _review: _review,
    }).fromJSON;
    function __createReview(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.review',
            method: 'POST',
            methodFqn: 'com.wixpress.critique.reviews.Reviews.CreateReview',
            url: resolveComWixpressCritiqueReviewsReviewsUrl({
                protoPath: '/v1/reviews',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createReview.fromReq = fromReq;
    __createReview.__isAmbassador = true;
    return __createReview;
}
/** Create Bulk Reviews. */
export function bulkCreateReview(payload) {
    var _a = serializer(_bulkCreateReviewRequest, { _reply: _reply, _review: _review }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateReviewResponse, {
        _bulkReviewResult: _bulkReviewResult,
        _reply: _reply,
        _review: _review,
    }).fromJSON;
    function __bulkCreateReview(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.review',
            method: 'POST',
            methodFqn: 'com.wixpress.critique.reviews.Reviews.BulkCreateReview',
            url: resolveComWixpressCritiqueReviewsReviewsUrl({
                protoPath: '/v1/bulk/reviews/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateReview.fromReq = fromReq;
    __bulkCreateReview.__isAmbassador = true;
    return __bulkCreateReview;
}
/**
 * Updates review content with provided data
 * @deprecated It has been replaced with com.wixpress.critique.reviews.UpdateReview(), and will be removed on 2024-07-31.
 */
export function updateReviewContent(payload) {
    var _a = serializer(_updateReviewContentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateReviewContentResponse, {
        _reply: _reply,
        _review: _review,
    }).fromJSON;
    function __updateReviewContent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.review',
            method: 'PUT',
            methodFqn: 'com.wixpress.critique.reviews.Reviews.UpdateReviewContent',
            url: resolveComWixpressCritiqueReviewsReviewsUrl({
                protoPath: '/v1/reviews/content/{reviewId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateReviewContent.fromReq = fromReq;
    __updateReviewContent.__isAmbassador = true;
    return __updateReviewContent;
}
/**
 * Updates a review.
 *
 *
 * Each time the review is updated, `revision` increments by 1. The existing `revision` must be included
 * when updating the review. This ensures you're working with the latest review information, and it prevents unintended overwrites.
 */
export function updateReview(payload) {
    var _a = serializer(_updateReviewRequest, { _reply: _reply, _review: _review }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateReviewResponse, {
        _reply: _reply,
        _review: _review,
    }).fromJSON;
    function __updateReview(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.review',
            method: 'PATCH',
            methodFqn: 'com.wixpress.critique.reviews.Reviews.UpdateReview',
            url: resolveComWixpressCritiqueReviewsReviewsUrl({
                protoPath: '/v1/reviews/{review.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateReview.fromReq = fromReq;
    __updateReview.__isAmbassador = true;
    return __updateReview;
}
/** Deletes a review by ID. */
export function deleteReview(payload) {
    var _a = serializer(_deleteReviewRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteReviewResponse, {
        _reply: _reply,
        _review: _review,
    }).fromJSON;
    function __deleteReview(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.review',
            method: 'DELETE',
            methodFqn: 'com.wixpress.critique.reviews.Reviews.DeleteReview',
            url: resolveComWixpressCritiqueReviewsReviewsUrl({
                protoPath: '/v1/reviews/{reviewId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteReview.fromReq = fromReq;
    __deleteReview.__isAmbassador = true;
    return __deleteReview;
}
/**
 * Deletes multiple reviews.
 *
 *
 * All reviews that meet the specified [`filter`](https://dev.wix.com/api/rest/reviews/sort-and-filter) criteria are deleted. To perform a dry run, use the intended filter options with [Query Reviews](https://dev.wix.com/docs/rest/api-reference/wix-reviews/reviews/query-reviews).
 *
 * When this endpoint is used, a bulk job is started and the job ID is returned. The job might not complete right away, depending on its size.
 */
export function bulkDeleteReviews(payload) {
    var _a = serializer(_bulkDeleteReviewsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteReviewsResponse, {}).fromJSON;
    function __bulkDeleteReviews(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.review',
            method: 'POST',
            methodFqn: 'com.wixpress.critique.reviews.Reviews.BulkDeleteReviews',
            url: resolveComWixpressCritiqueReviewsReviewsUrl({
                protoPath: '/v1/bulk/reviews/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteReviews.fromReq = fromReq;
    __bulkDeleteReviews.__isAmbassador = true;
    return __bulkDeleteReviews;
}
/**
 * Retrieves a list of reviews, given the provided paging, filtering, and sorting.
 * 100 reviews can be returned per request.
 *
 * Query Reviews runs with these defaults, which you can override:
 *
 * - `createdDate` is sorted in `ASC` order
 * - `paging.limit` is `100`
 *
 * For field support for filters and sorting, see
 * [Reviews: Supported Filters and Sorting](https://dev.wix.com/docs/rest/api-reference/wix-reviews/reviews/sort-and-filter).
 * To learn about working with _Query_ endpoints, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 */
export function queryReviews(payload) {
    var _a = serializer(_queryReviewsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryReviewsResponse, {
        _reply: _reply,
        _review: _review,
    }).fromJSON;
    function __queryReviews(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.review',
            method: 'POST',
            methodFqn: 'com.wixpress.critique.reviews.Reviews.QueryReviews',
            url: resolveComWixpressCritiqueReviewsReviewsUrl({
                protoPath: '/v1/reviews/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryReviews.fromReq = fromReq;
    __queryReviews.__isAmbassador = true;
    return __queryReviews;
}
/** Set reply on a review */
export function setReply(payload) {
    var _a = serializer(_setReplyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setReplyResponse, {
        _reply: _reply,
        _review: _review,
    }).fromJSON;
    function __setReply(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.review',
            method: 'PATCH',
            methodFqn: 'com.wixpress.critique.reviews.Reviews.SetReply',
            url: resolveComWixpressCritiqueReviewsReviewsUrl({
                protoPath: '/v1/reviews/{reviewId}/reply',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setReply.fromReq = fromReq;
    __setReply.__isAmbassador = true;
    return __setReply;
}
/** Removes reply from review */
export function removeReply(payload) {
    var _a = serializer(_removeReplyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeReplyResponse, {
        _reply: _reply,
        _review: _review,
    }).fromJSON;
    function __removeReply(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.review',
            method: 'DELETE',
            methodFqn: 'com.wixpress.critique.reviews.Reviews.RemoveReply',
            url: resolveComWixpressCritiqueReviewsReviewsUrl({
                protoPath: '/v1/reviews/{reviewId}/reply',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeReply.fromReq = fromReq;
    __removeReply.__isAmbassador = true;
    return __removeReply;
}
/**
 * Updates the moderation status of a review.
 *
 * Possible moderation statuses:
 * -  APPROVED: The review is published and viewable by site visitors.
 * -  REJECTED: The review is declined and not viewable by site visitors.
 */
export function updateModerationStatus(payload) {
    var _a = serializer(_updateModerationStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateModerationStatusResponse, {
        _reply: _reply,
        _review: _review,
    }).fromJSON;
    function __updateModerationStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.review',
            method: 'PATCH',
            methodFqn: 'com.wixpress.critique.reviews.Reviews.UpdateModerationStatus',
            url: resolveComWixpressCritiqueReviewsReviewsUrl({
                protoPath: '/v1/reviews/{reviewId}/moderate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateModerationStatus.fromReq = fromReq;
    __updateModerationStatus.__isAmbassador = true;
    return __updateModerationStatus;
}
/** Changes moderation status for multiple reviews */
export function bulkUpdateModerationStatus(payload) {
    var _a = serializer(_bulkUpdateModerationStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateModerationStatusResponse, {}).fromJSON;
    function __bulkUpdateModerationStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.review',
            method: 'POST',
            methodFqn: 'com.wixpress.critique.reviews.Reviews.BulkUpdateModerationStatus',
            url: resolveComWixpressCritiqueReviewsReviewsUrl({
                protoPath: '/v1/bulk/reviews/moderate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateModerationStatus.fromReq = fromReq;
    __bulkUpdateModerationStatus.__isAmbassador = true;
    return __bulkUpdateModerationStatus;
}
export function countReviews(payload) {
    var _a = serializer(_countReviewsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countReviewsResponse, {}).fromJSON;
    function __countReviews(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.review',
            method: 'POST',
            methodFqn: 'com.wixpress.critique.reviews.Reviews.CountReviews',
            url: resolveComWixpressCritiqueReviewsReviewsUrl({
                protoPath: '/v1/reviews/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countReviews.fromReq = fromReq;
    __countReviews.__isAmbassador = true;
    return __countReviews;
}
//# sourceMappingURL=http.impl.js.map